// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* styles/rtl.css */

/* Base styles */
[dir="rtl"] {
    text-align: right;
  }
  
  [dir="ltr"] {
    text-align: left;
  }
  
  /* Navigation styles */
  [dir="rtl"] nav ul {
    flex-direction: row-reverse;
  }
  
  [dir="rtl"] .navigation li {
    margin-left: 20px;
    margin-right: 0;
  }
  
  [dir="ltr"] .navigation li {
    margin-right: 20px;
    margin-left: 0;
  }
  
  /* Form styles */
  [dir="rtl"] .form-group {
    text-align: right;
  }
  
  [dir="rtl"] input, 
  [dir="rtl"] textarea, 
  [dir="rtl"] select {
    text-align: right;
  }
  
  /* Language switcher styles */
  .language-switcher {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  
  [dir="rtl"] .language-switcher {
    flex-direction: row-reverse;
  }
  
  .language-dropdown {
    padding: 5px 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    background: white;
  }
  
  /* Responsive font for Arabic */
  [dir="rtl"] body {
    font-family: 'Arial', 'Tahoma', sans-serif;
  }
  
  /* Margin and padding adjustments for RTL */
  [dir="rtl"] .container {
    padding-right: 20px;
    padding-left: 20px;
  }
  
  [dir="rtl"] .text-content {
    margin-right: 0;
    margin-left: auto;
  }`, "",{"version":3,"sources":["webpack://./src/styles/rtl.css"],"names":[],"mappings":"AAAA,mBAAmB;;AAEnB,gBAAgB;AAChB;IACI,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA,sBAAsB;EACtB;IACE,2BAA2B;EAC7B;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA,gBAAgB;EAChB;IACE,iBAAiB;EACnB;;EAEA;;;IAGE,iBAAiB;EACnB;;EAEA,6BAA6B;EAC7B;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA,+BAA+B;EAC/B;IACE,0CAA0C;EAC5C;;EAEA,2CAA2C;EAC3C;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB","sourcesContent":["/* styles/rtl.css */\n\n/* Base styles */\n[dir=\"rtl\"] {\n    text-align: right;\n  }\n  \n  [dir=\"ltr\"] {\n    text-align: left;\n  }\n  \n  /* Navigation styles */\n  [dir=\"rtl\"] nav ul {\n    flex-direction: row-reverse;\n  }\n  \n  [dir=\"rtl\"] .navigation li {\n    margin-left: 20px;\n    margin-right: 0;\n  }\n  \n  [dir=\"ltr\"] .navigation li {\n    margin-right: 20px;\n    margin-left: 0;\n  }\n  \n  /* Form styles */\n  [dir=\"rtl\"] .form-group {\n    text-align: right;\n  }\n  \n  [dir=\"rtl\"] input, \n  [dir=\"rtl\"] textarea, \n  [dir=\"rtl\"] select {\n    text-align: right;\n  }\n  \n  /* Language switcher styles */\n  .language-switcher {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n  \n  [dir=\"rtl\"] .language-switcher {\n    flex-direction: row-reverse;\n  }\n  \n  .language-dropdown {\n    padding: 5px 10px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    background: white;\n  }\n  \n  /* Responsive font for Arabic */\n  [dir=\"rtl\"] body {\n    font-family: 'Arial', 'Tahoma', sans-serif;\n  }\n  \n  /* Margin and padding adjustments for RTL */\n  [dir=\"rtl\"] .container {\n    padding-right: 20px;\n    padding-left: 20px;\n  }\n  \n  [dir=\"rtl\"] .text-content {\n    margin-right: 0;\n    margin-left: auto;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
